<template>
  <div
    id="upload-image-modal"
    tabindex="-1"
    aria-hidden="true"
    class="fixed top-0 left-0 right-0 z-50 items-center justify-center hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full"
  >
    <div class="relative w-full h-full max-w-3xl p-4 md:h-auto">
      <!-- Modal content -->
      <div class="relative p-4 bg-white rounded-lg shadow  sm:p-5">
        <!-- Modal header -->
        <div
          class="flex items-center justify-between pb-4 mb-4 border-b border-gray-200 rounded-t sm:mb-5 "
        >
          <h3 class="font-semibold text-gray-900 ">
            {{ labels['TITLE_ADD_IMAGE'][lg] }}
          </h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex "
            @click=" onClose()"
          >
            <svg
              aria-hidden="true"
              class="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <div class="grid gap-4 mb-4 sm:grid-cols-1 sm:gap-6 sm:mb-5">
          <div class="w-full">
            <p class="text-sm font-normal text-gray-500 ">
              {{ labels['TITLE_ADD_IMAGE_DESCRIPTION'][lg] }}
            </p>
            <div class="mt-2 w-full  text-left justify-left">
              <label
                for="name"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >Nom
                de l'image</label>
              <input
                id="name"
                v-model="name"
                v-focus
                type="text"
                name="name"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                placeholder="Ex. Nom du fichier"
              >
            </div>
            <div class="w-full py-4 hidden">
              <label
                class="inline-block pr-4 hover:cursor-pointer"
                for="flexSwitchChecked"
              >Garder le
                fond</label>
              <input
                id="flexSwitchChecked"
                v-model="transparent"
                class="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s]  "
                type="checkbox"
                role="switch"
              >
              <label
                class="inline-block pl-4 hover:cursor-pointer"
                for="flexSwitchChecked"
              >Retirer le
                fond</label>
            </div>
            <ContentImageUpload
              :id="`${item.id}-image-upload`"
              :ref="`content-image-upload-${item.id}`"
              :label="item.label && item.label[lg]"
            />
          </div>
        </div>
        <div class="flex items-center justify-end">
          <button
            type="button"
            class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
            @click=" onClose()"
          >
            Annuler
          </button>
          <button
            type="button"
            class="inline-flex items-center text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  "
            @click="onValidate"
          >
            Valider
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import labels from "@/assets/lg/images-types.json"
    import ContentImageUpload from '@/components/content/ContentImageUpload.vue'


    export default {
        name: 'UploadImageModal',


        components: {
            ContentImageUpload
        },

        props: {
            'input': String
        },
        data() {
            return ({
                lg: "FR",
                labels: labels,
                name: "",
                transparent: false,
                item: {
                    id: "1",
                    label: {
                        'EN': "",
                        'FR': ''
                    }
                },
            })
        },


        watch: {
            'input': function () {
                this.name = this.input;

                let ref = "content-image-upload-1"

                if (this.input == "")
                {
                    this.$refs[ref].resetData()
                }
               


            }
        },
        methods: {
            onValidate() {
            
                let ref = "content-image-upload-1"
                let file =
                {
                    name: "",
                    url: null
                }
                if (this.$refs[ref]) {
                    file = this.$refs[ref].getData()

                }

                if (file.url == undefined) {
                    alert("Sélectionner un fichier");
                    return;
                }

                if ((this.name == undefined) || (this.name == '')) {
                    alert("Saissir un nom pour l'image");
                    return;
                }

                let item =
                {
                    name: this.name,
                    transparent: this.transparent,
                    file: file
                }
 
                this.$emit("addImage", item)


            },

            onClose() {
                this.$emit("close")
            }
        },
    }
</script>